import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

function ConfirmModal({
  show,
  onHide,
  title = 'Confirmar',
  message = null,
  children = null,
  alertVariant = 'warning',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  confirmVariant = 'danger',
  centered = true,
}) {
  return (
    <Modal show={show} onHide={onHide} centered={centered}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message ? <Alert variant={alertVariant}>{message}</Alert> : null}
        {children}
      </Modal.Body>
      <Modal.Footer>
        {cancelLabel && <Button variant="secondary" onClick={onHide}>{cancelLabel}</Button>}
        <Button variant={confirmVariant} onClick={() => { if (onConfirm) onConfirm(); }}>{confirmLabel}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmModal;
